<script lang="ts">
  import { onMount } from "svelte";
  import { TableHeaderField, TableDataField, type ITableField } from "../../components/Table";
  import Button from "../../components/Button.svelte";
  import NumberInputModal from "../../components/Modal/NumberInputModal.svelte";
  import MainLayout from "../../layout/MainLayout.svelte";
  import { weightIngressDtoFields } from "../../utils/TableFields/weight-ingress-dto.fields";
  import { loading, records, initList, saveImmissionWork, saveImmissionSkip, onDateFilterChanged, filter, showCompleted, search } from "./entrance.store";
  import type { IWeightIngressDTO } from "../../services/DTO/weight-ingress-dto";
  import SearchHeader from "../../components/SearchHeader.svelte";
  import DateInputString from "../../components/Form/Fields/DateInputString.svelte";
  import { isUserRoleWOR } from "../../app.store";
  import { get } from "svelte/store";
  import Label from "../../components/Form/Label.svelte";
  import Switch from "../../components/Form/Fields/Switch.svelte";

  onMount(initList);

  let colspanValue = weightIngressDtoFields.length + 2;
  let visibleFields = weightIngressDtoFields;
  let buttonClass = get(isUserRoleWOR) ? "worker-button" : "";

  let immissionModalOpen = false;
  let immissionNumber = 0;
  let immissionRecord: IWeightIngressDTO | null = null;

  function renderField(field: ITableField<any>, record: any) {
    if (field.render != null && typeof field.render === "function") {
      return field.render(record);
    }
    return record[field.name];
  }

  function confirmImmission(event: CustomEvent) {
    if (!!immissionRecord) {
      let item = Object.assign({}, immissionRecord);
      let quantity: number = event.detail;
      if (quantity > 0) {
        saveImmissionWork(item, quantity);
      }
    }
    immissionRecord = null;
  }

  function declineImmission() {
    immissionRecord = null;
  }

  function immitItemWork(item: IWeightIngressDTO) {
    /*
    immissionRecord = item;
    immissionNumber = 0; // make sure it's zero
    immissionModalOpen = true;
    */

    saveImmissionWork(item, 1);
  }

  function immitItemSkip(item: IWeightIngressDTO) {
    saveImmissionSkip(item, 1);
  }
</script>

<MainLayout>
  <NumberInputModal
    title="Immissione capi"
    message="Specificare la quantità di capi da immettere."
    bind:numberValue={immissionNumber}
    bind:open={immissionModalOpen}
    on:confirm={confirmImmission}
    on:decline={declineImmission}
  />

  <SearchHeader entitySingular="capo" entityPlural="capi" searchFieldVisible={false} numRecords={$records != null ? $records.length : 0}>
    <div slot="search" class="level-item weight-label-search-box">
      <div style="min-width: 5rem;">
        <DateInputString name="" placeholder="Data Macellazione" required={false} value={$filter.criteria.refDate} on:select={onDateFilterChanged} />
      </div>
      <p class="control" style="margin-left:1rem;">
        <Button klass="is-warning" on:click={search}>
          <span>Aggiorna</span>
        </Button>
      </p>
      <div style="min-width: 5rem;margin-left:3rem;">
        <Label>Mostra completati</Label>
      </div>
      <div style="min-width: 5rem;margin-left:1rem;">
        <Switch name="" bind:value={$showCompleted} on:toggle={search} />
      </div>
    </div>
  </SearchHeader>

  <table class="table is-striped is-fullwidth table-base">
    <thead>
      <tr>
        {#each visibleFields as field}
          <TableHeaderField klass={field.titleClass || ""} sortable={field.sortable}>
            {field.title}
          </TableHeaderField>
        {/each}

        <TableHeaderField klass="table-buttons"></TableHeaderField>
        <TableHeaderField klass="table-buttons"></TableHeaderField>
      </tr>
    </thead>

    <tbody>
      {#if $loading == false}
        {#if $records.length == 0}
          <tr class="table-no-data">
            <td colspan={colspanValue}> nessun elemento da visualizzare </td>
          </tr>
        {:else}
          {#each $records as record}
            <tr>
              {#each visibleFields as field}
                <TableDataField klass={field.dataClass || ""}>
                  {@html renderField(field, record)}
                </TableDataField>
              {/each}

              <TableDataField klass="has-text-centered">
                <!--<Button klass="is-warning" disabled={record.remainingItems <= 0} on:click={(_) => immitItem(record)}>Immetti</Button>-->
                <Button
                  klass="is-warning {buttonClass}"
                  disabled={record.slaughterItem.worked == 1 || record.slaughterItem.skipped == 1 || !record.slaughterItem.lotNumber}
                  on:click={(_) => immitItemWork(record)}>Immetti</Button
                >
              </TableDataField>
              <TableDataField klass="has-text-centered">
                <Button
                  klass="is-danger {buttonClass}"
                  disabled={record.slaughterItem.worked == 1 || record.slaughterItem.skipped == 1 || !record.slaughterItem.lotNumber}
                  on:click={(_) => immitItemSkip(record)}>Salta</Button
                >
              </TableDataField>
            </tr>
          {/each}
        {/if}
      {:else}
        <tr class="table-no-data">
          <td colspan={colspanValue}>
            <div class="table-loader" />
          </td>
        </tr>
      {/if}
    </tbody>
  </table>
</MainLayout>

<style>
  .table-base {
    margin-top: 1.5rem;
  }

  .table-base tr.table-no-data {
    transition: all 1s linear;
  }
</style>
